<template>
  <layout>
    <div
      v-if="isSkipToFreeWifi === true || showButtons"
      id="social-holders"
      class="social-btn-holder loginBorder"
      :class="{ appStyle: listStyle === 'app', defaultStyle: listStyle === 'default' }"
      :style="'border-radius:' + borderRadius"
    >
      <custom-btn
        v-if="isSkipToFreeWifi === false && logins.includes('email')"
        :id="'option_' + logins.indexOf('email')"
        :ref="'option_' + logins.indexOf('email')"
        :api="api"
        action="custom-login"
        :wftkn="wftkn"
      />
      <twilio-btn
        v-if="isSkipToFreeWifi === false && logins.includes('sms')"
        :id="'option_' + logins.indexOf('sms')"
        :ref="'option_' + logins.indexOf('sms')"
      />
      <whats-app-btn
        v-if="isSkipToFreeWifi === false && logins.includes('whatsapp')"
        :id="'option_' + logins.indexOf('whatsapp')"
        :ref="'option_' + logins.indexOf('whatsapp')"
      />
      <passcode-btn
        v-if="isSkipToFreeWifi === false && logins.includes('passcode')"
        :id="'option_' + logins.indexOf('passcode')"
        :ref="'option_' + logins.indexOf('passcode')"
      />
      <passcode-btn-v2
        v-if="!isSkipToFreeWifi && logins.includes('passcode v2')"
        :id="'option_' + logins.indexOf('passcode v2')"
        :ref="'option_' + logins.indexOf('passcode v2')"
      />
      <skip-login
        v-if="isSkipToFreeWifi === true || logins.includes('freewifi')"
        :id="'option_' + logins.indexOf('freewifi')"
        :ref="'option_' + logins.indexOf('freewifi')"
        :api="api"
        action="freewifi"
        :wftkn="wftkn"
      />
      <stripe-btn
        v-if="isSkipToFreeWifi === false && logins.includes('credit card')"
        :id="'option_' + logins.indexOf('credit card')"
        :ref="'option_' + logins.indexOf('credit card')"
        :api="api"
        action="creditcard"
        :wftkn="wftkn"
        @showPaymentOptions="pushToCreditCardOption()"
      />
    </div>

    <a
      v-if="showButtons && isPaidCampaign"
      class="goback-payment"
      href="#"
      @click.prevent="backToPaymentsPage()"
    >
      ← {{ $t('back_button') }}
    </a>

    <transition name="slide-fade">
      <div v-if="showTwilioFields" class="custom-field-holder">
        <twilio-fields
          :api="api"
          :wftkn="wftkn"
          :consent-accepted="isConsentAccepted"
          action="sms"
        />
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-if="showWhatsAppFields" class="custom-field-holder">
        <whats-app-fields
          :api="api"
          :wftkn="wftkn"
          :consent-accepted="isConsentAccepted"
          action="whatsapp"
        />
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-if="showCustomFields" class="custom-field-holder">
        <custom-fields :api="api" action="custom-login" :wftkn="wftkn" :fields="fields" />
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-if="showPasscodeFields" class="custom-field-holder">
        <passcode-fields
          :api="api"
          :consent-accepted="isConsentAccepted"
          :wftkn="wftkn"
          action="pass-code"
        />
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-if="showPasscodeV2Fields" class="custom-field-holder">
        <passcode-fields-v2
          :api="api"
          :consent-accepted="isConsentAccepted"
          :wftkn="wftkn"
          action="passcode_v2"
        />
      </div>
    </transition>

  </layout>
</template>

<script>
  import Layout from './layout'
  import CustomBtn from '../components/social-buttons/custom.vue'
  import SkipLogin from '../components/social-buttons/skip.vue'
  import TwilioBtn from '../components/social-buttons/twilio.vue'
  import WhatsAppBtn from '../components/social-buttons/whatsapp.vue'
  import PasscodeBtn from '../components/social-buttons/passcode.vue'
  import PasscodeBtnV2 from '../components/social-buttons/passcodev2.vue'
  import TwilioFields from '../components/twilio-connect/twilio-connect.vue'
  import WhatsAppFields from '../components/whatsapp-connect/whatsapp-connect.vue'
  import CustomFields from '../components/custom/custom.vue'
  import PasscodeFields from '../components/passcode/passcode.vue'
  import PasscodeFieldsV2 from '../components/passcode/passcodev2.vue'
  import StripeBtn from '../components/social-buttons/stripe.vue'
  import screens from '../utils/pageSchema'

  export default {
    components: {
      Layout,
      CustomBtn,
      StripeBtn,
      CustomFields,
      SkipLogin,
      TwilioBtn,
      WhatsAppBtn,
      PasscodeBtn,
      PasscodeBtnV2,
      TwilioFields,
      WhatsAppFields,
      PasscodeFields,
      PasscodeFieldsV2,
    },
    data() {
      return {
        showCustomFields: false,
        showTwilioFields: false,
        showWhatsAppFields: false,
        showPasscodeFields: false,
        showPasscodeV2Fields: false,
        showStripeForm: false,
        selectedPlan: null,
        planId: null,
        showSocialIcons: true,
      }
    },
    computed: {
      isSkipToFreeWifi() {
        return false
      },
      originalData() {
        return this.$store.state.originalData
      },
      baseData() {
        return this.$store.state.baseData
      },
      wftkn() {
        return this.$store.state.wftkn
      },
      api() {
        return this.$store.state.api
      },
      logins() {
        return this.$store.state.logins
      },
      listStyle() {
        if (this.baseData.loginOptions) {
          return this.baseData.layouts.appLayout
        }
        return 'default'
      },
      borderRadius() {
        if (this.baseData.sizes && this.baseData.sizes.loginBtnsRadius) {
          return this.baseData.sizes.loginBtnsRadius
        }
        return 32
      },
      isPaidCampaign() {
        return !!this.baseData.paymentPlans
      },
      showButtons() {
        return (
          this.showSocialIcons &&
          !this.showCustomFields &&
          !this.showTwilioFields &&
          !this.showWhatsAppFields &&
          !this.showPasscodeFields &&
          !this.showPasscodeV2Fields
        )
      },
      fields() {
        return this.$store.state.fields
      },
      isConsentAccepted() {
        return typeof this.$store.state.consentAgreed !== 'undefined'
          ? this.$store.state.consentAgreed === true || this.$store.state.consentAgreed === 1
          : undefined
      },
    },
    watch: {
      showButtons() {
        this.animateSocial()
      },
      baseData: {
        deep: true,
        handler() {
          this.animateSocial()
          this.checkAndAutoInitiateLogin()
        },
      },
    },
    updated: function () {
      this.$store.state.baseData.backButton = true
    },
    created() {
      this.$eventHub.$on('showCustom', this.showCustomFieldsArea)
      this.$eventHub.$on('showTwilio', this.showTwilioFieldsArea)
      this.$eventHub.$on('showWhatsApp', this.showWhatsAppFieldsArea)
      this.$eventHub.$on('showPasscode', this.showPasscodeFieldsArea)
      this.$eventHub.$on('showPasscodev2', this.showPasscodeV2FieldsArea)
    },
    beforeDestroy() {
      this.$eventHub.$off('showCustom')
      this.$eventHub.$off('showTwilio')
      this.$eventHub.$off('showWhatsApp')
      this.$eventHub.$off('showPasscode')
      this.$eventHub.$off('showPasscodev2')
    },
    mounted() {
      this.animateSocial()
      this.checkAndAutoInitiateLogin()
    },
    methods: {
      showCustomFieldsArea(value) {
        this.showCustomFields = value
      },

      showTwilioFieldsArea(value) {
        this.showTwilioFields = !this.showTwilioFields
      },

      showWhatsAppFieldsArea(value) {
        this.showWhatsAppFields = !this.showWhatsAppFields
      },

      showPasscodeFieldsArea(value) {
        this.showPasscodeFields = value
      },

      showPasscodeV2FieldsArea(value) {
        this.showPasscodeV2Fields = value
      },
      async backToPaymentsPage() {
        await screens.back()
      },
      async pushToCreditCardOption() {
        await screens.navigateTo('payment-plans', { option: 'creditcard' })
      },
      animateSocial() {
        setTimeout(() => {
          const btns = document.getElementsByClassName('social-btn')
          for (let i = 0; i < btns.length; i++) {
            setTimeout(() => {
              if (btns[i]) {
                btns[i].style.opacity = 1
                btns[i].style.marginLeft = '0'
              }
            }, 200 + i * 50)
          }
          this.sortOptions()
        }, 20)
      },
      sortOptions() {
        const main = document.getElementById('social-holders')

        if (main && main.children) {
          ;[].map
            .call(main.children, Object)
            .sort(function (a, b) {
              return +a.id.match(/\d+/) - +b.id.match(/\d+/)
            })
            .forEach(function (elem) {
              main.appendChild(elem)
            })
        }
      },
      checkAndAutoInitiateLogin() {
        const defaultCampaign = sessionStorage.getItem('defaultCampaign')
        const defaultLocation = sessionStorage.getItem('defaultLocation')
        const loginMethods = this.logins
        if (this.baseData?.preview) {
          this.$eventHub.$emit('showPasscodev2', this.baseData?.development?.editPasscodeV2)
          return
        }

        const allowedMethods = ['sms', 'passcode', 'freewifi', 'email']
        if (
          loginMethods.length === 1 &&
          !this.baseData?.development?.preview &&
          defaultCampaign !== 'true' &&
          defaultLocation !== 'true'
        ) {
          const loginName = loginMethods[0]
          if (allowedMethods.includes(loginName)) {
            if (loginName === 'sms') {
              this.$eventHub.$emit('showTwilio', true)
            } else if (loginName === 'passcode') {
              this.$eventHub.$emit('showPasscode', true)
            } else if (loginName === 'email') {
              this.$eventHub.$emit('showCustom', true)
            } else if (loginName === 'freewifi') {
              const url = `${this.api}&action=freewifi&wftkn=${this.wftkn}`
              window.open(url, '_self')
            }
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .social-btn .fa,
  .social-btn .far,
  .social-btn .fab {
    margin-right: 10px;
    font-size: 18px;
    width: 18px;
    height: 18px;
    text-align: center;
  }
  .social-btn:last-child {
    margin-bottom: 0;
  }

  .loginBorder {
    .social-btn {
      border-radius: inherit;
    }
  }

  .social-btn {
    color: white;
    width: 90%;
    max-width: 320px;
    border: none;
    border-radius: 32px;
    padding: 15px 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    outline: none;
    text-decoration: none;
    margin-bottom: 10px;
    box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    position: relative;
    transform: translateY(0);
  }

  .social-btn:hover {
    transform: translateY(-2px);
    box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.2);
  }

  .social-btn:active {
    transform: translateY(0);
    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);
    transition: all 0.1s ease-in-out;
  }

  .social-btn:last-child {
    margin-bottom: 0;
  }
  .appStyle {
    &.social-btn-holder {
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      width: 70%;
      max-width: 400px;
      border-radius: 32px;
      .social-btn {
        margin: 10px;
        margin-left: 0;
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 65px;
        width: 65px;
        padding: 0;
        transition: all 0.2s ease-in-out;
        transform: translateY(0);
        span {
          display: none;
        }
        .fa {
          margin: 0;
          font-size: 32px;
          height: auto;
          width: auto;
        }
        .fab {
          margin: 0;
          font-size: 32px;
          margin-right: 8px;
        }
        .fa-lock {
          margin: 0;
        }

        &:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 3px 6px 12px 3px rgba(0, 0, 0, 0.25);
        }

        &:active {
          transform: translateY(0) scale(1);
          box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.3);
          transition: all 0.1s ease-in-out;
        }
      }
    }
  }
  .custom-field-holder {
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
  .custom-field-holder a {
    color: inherit;
    text-decoration: none;
    display: inline-block;
    margin: 15px 0;
    border: none;
  }
</style>
